import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicTableComponent } from './dynamic-table/dynamic-table.component';
import { RowActionComponent } from './row-action/row-action.component';
import { AgGridModule } from 'ag-grid-angular';
import { FormFieldModule } from '../form-field/form-field.module';
import { InputModule } from '../input/input.module';
import { TableSelectComponent } from './components/table-select/table-select.component';
import { SelectModule } from '../select/select.module';
import { FormsModule } from '@angular/forms';
import {TranslateModule} from "@ngx-translate/core";

@NgModule({
  declarations: [DynamicTableComponent, RowActionComponent, TableSelectComponent],
  exports: [DynamicTableComponent, TableSelectComponent],
  imports: [CommonModule, FormsModule, AgGridModule, FormFieldModule, InputModule, SelectModule, TranslateModule],

})
export class DynamicTableModule {}
